import { memo, useEffect, useState } from "react";

import { FiShare } from "react-icons/fi";
import Cookies from "js-cookie";

import { checkIosPwa, checkIsAndroid, checkIsIos } from "helpers/devices";
import { VStack } from "components/landingNew/shared/ui/Stack";

import cls from "./InstallPwaPopup.module.scss";
import { Text } from "components/landingNew/shared/ui/Text";
import { Button } from "components/landingNew/shared/ui/Button";
import { ReactComponent as Close } from "static/img/ic-cross.svg";
import { Icon } from "components/landingNew/shared/ui/Icon";

const isAndroid = checkIsAndroid();
const isIos = checkIsIos();

export const InstallPwaPopup = memo(({ closePopup, isOpen }) => {
    const [isShowPopup, setIsShowPopup] = useState(false);
    const [promptInstall, setPromptInstall] = useState(null);
    const [isShowInstruction, setIsShowInstruction] = useState(false);

    useEffect(() => {
        if (isAndroid) {
            const handler = (e) => {
                e.preventDefault();

                setIsShowPopup(true);
                setPromptInstall(e);
            };

            window.addEventListener("beforeinstallprompt", handler);

            return () => window.removeEventListener("transitionend", handler);
        } else if (isIos && !checkIosPwa()) {
            setIsShowPopup(true);
        }
    }, []);

    const dontShowHandler = () => {
        Cookies.set("hidePwaInstallPopup", true, { expires: 365 });
        closePopup();
    };

    const installHandler = (e) => {
        e.preventDefault();

        if (!promptInstall) {
            return;
        }

        promptInstall.prompt();
        closePopup();
    };

    const showInstructionHandler = (e) => {
        e.preventDefault();
        setIsShowInstruction(true);
    };

    if (!isShowPopup || !isOpen) {
        return null;
    }

    return (
        <VStack className={cls.pwaPopup} align="center" gap={20}>
            <Icon className={cls.icon} Svg={Close} width={16} height={16} clickable onClick={() => closePopup()} />
            <Text title="Установить приложение" variant="blue" size="l-strong" />
            <VStack gap={15} align="center">
                <Button maxWidth onClick={(e) => (isAndroid ? installHandler(e) : showInstructionHandler(e))}>
                    <Text text="Установить" size="l" variant="white" />
                </Button>
                <Button maxWidth variant="light" onClick={dontShowHandler}>
                    <Text text="Больше не показывать" size="l" variant="grey" />
                </Button>
            </VStack>

            {isShowInstruction && (
                <VStack align="center">
                    <p className={cls.instruction}>
                        Нажмите <FiShare /> <b>Поделиться</b>
                        <br /> в нижнем меню браузера <br /> и выберите <b>На экран "Домой"</b>, <br /> затем -{" "}
                        <b>Добавить</b>
                    </p>
                </VStack>
            )}
        </VStack>
    );
});
